import { Steps } from 'intro.js-react';
import { useLocation } from 'wouter';

import { useTour } from '../../contexts/tour'
import { hide as hideTour, setStep } from '../../slices/local/tour';
import { useAppSelector, useAppDispatch } from '../../state/hooks';
import { useCallback, useRef } from 'react';

let surviveLocationChange = false;

const Tour = () => {
  const dispatch = useAppDispatch();
  const stepsRef = useRef();
  const state = useAppSelector(state => state?.tour);
  const tour = useTour();
  const [, navigate] = useLocation();

  const onBeforeChange = useCallback(nextStepIndex => {
    const step = tour.steps[nextStepIndex];

    dispatch(setStep(nextStepIndex));

    surviveLocationChange = false;
    if(step.location != window.location.pathname) {
      surviveLocationChange = true;
      navigate(step.location, { replace: true });
    }
  });

  const onAfterChange = useCallback(nextStepIndex => {
    surviveLocationChange = false;

    if(stepsRef.current) {
      stepsRef.current.updateStepElement(nextStepIndex);
    }
  });

  const onBeforeExit = useCallback(() => {
    if(surviveLocationChange) {
      return false;
    }
  }, [ surviveLocationChange ]);

  const onExit = useCallback(currentStep => {
    if(currentStep >= 0) {
      dispatch(hideTour());
    }
  });

  return (
    <Steps
      enabled={state.enabled}
      initialStep={state.step}
      steps={tour.steps}
      ref={stepsRef}
      onBeforeChange={onBeforeChange}
      onBeforeExit={onBeforeExit}
      onChange={onAfterChange}
      onExit={onExit}
      options={{ disableInteraction: true, exitOnOverlayClick: false }}
    />
  );
}

export { Tour };
